<template>
    <div class='timing'>
        <div class='timing_herder'>
            <span class='timing_back'
                  @click="clickBack"><i></i></span>
            <p>定时发送邀请短信</p>
        </div>
        <div class='timing_mian'
             v-if='loading'>
            <div class='timing_mian-top'>
                <div class='timing_mian-top-title'>
                    <h2>接收对象：</h2><span>所带全部班级</span>
                </div>
                <div>
                    <h2 class='timing_mian-top-title'>短信内容：</h2>
                    <div class='timing_mian-top-msg'>{{content}}</div>
                </div>
            </div>
            <div class='timing_mian-bottom'>
                <div class='timing_mian-bottom-title'><i></i>以下是为您推荐的发送时间，点击可修改</div>
                <ul class='timing_mian-bottom-ul'>
                    <template v-for="(tim,index) in timingList">
                        <li @click="timingTime(tim,index)"
                            class='timing_mian-bottom-li'
                            :key="index">
                            <span :class="['timing_mian-bottom-li-span', tim.is_send?'yesSned':'noSned']">{{tim.time|defaultTime}}</span>
                            <div v-if="tim.is_send"
                                 class='timing_mian-li-right nohasSned'>已发送</div>
                            <div v-else
                                 @click.stop="clickSwitch(tim,index)"
                                 :class="['timing_mian-li-right',tim.switch?'openhasSned':'closehasSned']">
                                <i></i>
                            </div>
                        </li>
                    </template>
                </ul>
            </div>
            <div class="fix_bottom">
                <button class="one_click-open"
                        @click="oneClickOpen">一键开启</button>
            </div>
        </div>
        <picker v-model="beginVisible"
                :data-items="beginItems"
                @change="onTimeChange">
            <div class="bottom-content clearfix"
                 slot="bottom-content">
                <span @click="cancel">取消</span>
                <span class="btn"
                      @click="Determine">确定</span>
            </div>
        </picker>
        <div class='tip_content'
             v-if='showTip'>{{showTipcontent}}</div>
    </div>
</template>
<script type="text/ecmascript-6">
import picker from "VIEWS/activity/2022summer/tea/picker/picker.vue";
export default {
    data () {
        return {
            beginVisible: false, //选择时间
            beginItems: [],//
            timeListAll: [],//全部小时数
            timeListToday: [],//间隔小时数
            content: '',
            datelen: 0,
            showTip: false,
            showTipsetTime: true,
            showTipcontent: '时间已过，请重新设置后再开启',
            timeIndex: 0,
            ChoiceTime: null,//选择的时间
            timingList: [],
            loading: false,
            today: {
                name: "",
                id: ""
            }, //今天
            is_end: false,
        }
    },
    async created () {
        let endDay = new Date('2024/02/29 11:59:59').getTime();
        let today = new Date().getTime();
        if (today < endDay) { // 没结束
            this.is_end = true;//根据路由判断是否是做题进的本页面
        }
        let info = JSON.parse(localStorage.getItem('info'));
        let unitList = info.units, unit = null;
        let has_sf = false
        for (let i = 0; i < unitList.length; i++) {
            if (unitList[i].sid == 11) {
                has_sf = true
            }
            // if (unitList[i].sid == 21 || unitList[i].sid == 51) {
            //     unit = unitList[i];
            //     break;
            // }
        }
        this.content = `家长好，寒假期间布置了本学期复习试题和下学期预习课程，${has_sf ? '还有书法线上课，' : ''}点击这个链接https://tbkt.cn 让学生假期多练习，开学后我会进行点评。【${info.real_name}老师】`
        await this.getsendlist();
    },
    filters: {
        defaultTime (value) {
            let _t = new Date(value);
            _t = `${_t.getMonth() + 1}月${_t.getDate()}日 ${_t.getHours()}点`
            return _t;
        }
    },
    methods: {
        clickBack () {
            this.$router.go(-1);
        },
        clickSwitch (tim, index) {
            if (!this.showTipsetTime) return false;
            if (!this.is_end) {
                this.showTipclick('活动已结束！');
                return false;
            }

            if (+ new Date() > tim.time) {
                this.showTipclick('时间已过，请重新设置后再开启');
                return false;
            }
            this.ChoiceTime = null;
            this.timeIndex = index;
            tim.switch = !tim.switch;
            tim.send_date = !tim.switch ? 0 : tim.time;
            let content = tim.switch ? '定时短信已开启' : '定时短信已关闭';
            this.showTipclick(content);
        },
        showTipclick (content) {
            this.showTipcontent = content;
            this.showTip = true;
            this.showTipsetTime = false;
            setTimeout(() => {
                this.showTip = false;
                this.showTipsetTime = true;
            }, 1000);
        },
        timingTime (tim, index) {
            console.log(tim, index)
            if (!this.is_end) {
                this.showTipclick('活动已结束！');
                return false;
            }
            if (tim.send_date) return false;
            this.ChoiceTime = null;
            this.timeIndex = index;
            let _start = 1705248000000;//(2023.01.15 00:00:00)
            let _new = (+ new Date());
            let _t = _start > _new ? _start : _new;
            this.makeTime(_t);
        },
        onTimeChange (date, time) {
            if (date) {
                let _hours = (date.id == this.today.id) ? this.timeListToday : this.timeListAll;
                this.beginItems[1].values = _hours;
                if (time) {
                    this.ChoiceTime = (date.id + ' ' + time.id);
                }
            } else {
                let _day = this.beginItems[0].values[0];
                let _hours = this.beginItems[1].values[0];
                this.ChoiceTime = (_day.id + ' ' + _hours.id);
            }
        },
        makeTime (tim) {
            this.getHours(tim);
            let _array = [{ name: 'name', values: [] }, { name: 'name', values: [] }];
            let _daytime = new Date(tim).getHours(); //现在小时
            _array[1].values = (_daytime >= 8 && _daytime < 19) ? this.timeListToday : this.timeListAll;
            _array[0].values = this.getDays(tim);
            this.beginItems = _array;
            this.beginVisible = true;
        },
        getHours (tim) {//获取小时列表
            let _time = new Date(tim),
                _hours = _time.getHours(),
                _endHours = 21,//截止小时时间
                _list = [], //小时列表
                h = 14, //间隔小时
                _h = 8; //开始小时
            for (let i = 0; i < h; i++) {
                let new_time = {};
                new_time.id = _h < 10 ? `0${_h}:00:00` : `${_h}:00:00`
                new_time.name = _h + "点";
                _list.push(new_time);
                _h = _h + 1;
            }
            this.timeListAll = _list;
            //  ----------------------------------------------------------------------------
            let dayHour = "";
            dayHour = _hours < 8 ? 7 : _hours;
            let n = _endHours - dayHour;
            let _timeListAll = []; //今天时间列表
            for (let i = 0; i < n; i++) {
                let new_time = {};
                new_time.id = (dayHour + 1) < 10 ? `0${(dayHour + 1)}:00:00` : `${(dayHour + 1)}:00:00`;
                new_time.name = (dayHour + 1) + "点";
                _timeListAll.push(new_time);
                dayHour = dayHour + 1;
            }
            this.timeListToday = _timeListAll;
        },
        getDays (tim) { //获取日期天数
            let _time = new Date(tim),
                _endHours = 21,//截止小时时间
                _dayList = this.getDiffDate(tim); //日期列表
            this.today = this.getDate(_time);
            return _dayList;
        },
        getDate (_time) {
            let _date = new Date(_time),
                _obj = {},
                _getMonth = _date.getMonth() + 1,
                _getDate = _date.getDate(),
                day = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
            _obj.name = `${_getMonth}月${_getDate}日（${day[_date.getDay()]}）`;
            _obj.id = `${_date.getFullYear()}${_getMonth < 10 ? "-0" : "-"}${_getMonth}${_getDate < 10 ? "-0" : "-"}${_getDate}`;
            return _obj;
        },
        getDiffDate (start, end) {
            var startTime = new Date(start);
            var endTime = new Date('2024/02/29 21:00:00');//短信结束时间
            console.log(startTime)
            console.log(endTime)
            let date = [];
            while ((endTime.getTime() - startTime.getTime()) > 0) {
                date.push(this.getDate(startTime))
                startTime.setDate(startTime.getDate() + 1);
            }
            return date;
        },
        cancel () {
            this.beginVisible = !this.beginVisible;
        },
        Determine () {
            if (this.ChoiceTime) this.ChoiceTime = this.ChoiceTime.replace(/-/g, '/');
            let _obj = this.timingList[this.timeIndex];
            _obj.time = (+ new Date(this.ChoiceTime));
            if (_obj.switch) {
                _obj.send_date = + (new Date(this.ChoiceTime));
            }
            _obj.ischange = _obj.time == _obj.default_date ? 0 : 1;
            this.timingList.splice(this.timeIndex, 1, _obj)
            this.beginVisible = !this.beginVisible;
        },
        getsendlist () {
            this.$http.post(API_URL_HD_API + '/winter2023/tea/get_send_list/').then((res) => {
                if (res.data.response == 'ok') {
                    let _data = res.data.data;
                    _data.map((m) => {
                        m.switch = m.send_date ? true : false;
                        m.send_date = m.send_date * 1000;
                        m.default_date = m.default_date * 1000;
                        m.time = m.send_date ? m.send_date : m.default_date;
                    });
                    this.loading = true;
                    this.timingList = _data;
                }
            })
        },
        sendSms () {
            this.timingList.map((m) => {
                let _str = m.send_date.toString();
                m.send_date = _str.length == 13 ? m.send_date / 1000 : m.send_date;
            });
            let _data = {
                "send_type": 1,
                "data": this.timingList,
                "content": this.content
            }
            this.$http.post(API_URL_HD_API + '/winter2023/tea/send_sms/', _data).then((res) => {
                if (res.data.response == 'ok') {

                }
            })
        },
        // 一键开启
        oneClickOpen () {
            if (!this.is_end) {
                this.showTipclick('活动已结束！');
                return;
            }
            if (!this.showTipsetTime) return;
            let isOpen = false; //是否开启
            this.timingList.filter((item, index) => {
                if (+ new Date() > item.time) return;
                item.switch = true;
                item.send_date = item.time;
                isOpen = true;
            });
            this.$nextTick(() => {
                if (isOpen) this.showTipclick('定时短信已开启')
            })
        },
    },
    beforeDestroy () {
        this.sendSms()
    },
    components: {
        picker
    }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.timing {
    width: 100%;
    height: 100vh;
    background: #f3f3f3;
    .timing_herder {
        height: 96px / $ppr;
        line-height: 96px / $ppr;
        background: #ffffff;
        .timing_back {
            width: 64px / $ppr;
            height: 96px / $ppr;
            display: inline-block;
            position: absolute;
            text-align: center;
            top: 0;
            left: 0;
            z-index: 3;
            i {
                width: 16px / $ppr;
                height: 30px / $ppr;
                background: url("./img/icon_img_23.png") no-repeat;
                background-size: 100% 100%;
                display: inline-block;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
            }
        }
        p {
            width: 100%;
            text-align: center;
            height: 90px / $ppr;
            display: inline-block;
            font-size: 36px / $ppr;
            color: #333333;
        }
    }
    .timing_mian {
        margin-top: 20px / $ppr;
        padding-bottom: 160px / $ppr;
        .timing_mian-top {
            height: 390px / $ppr;
            background: #fff;
            padding: 24px / $ppr;
            color: #999999;
            font-size: 30px / $ppr;
            .timing_mian-top-title {
                width: 100%;
                height: 60px / $ppr;
                line-height: 60px / $ppr;
            }
            h2 {
                font-size: 30px / $ppr;
                font-weight: 600;
                display: inline-block;
                color: #333333;
            }
            .timing_mian-top-msg {
                font-size: 28px / $ppr;
                margin-top: 15px / $ppr;
                padding: 20px / $ppr;
                background: #f6f6f6;
                border-radius: 10px / $ppr;
            }
        }
        .timing_mian-bottom {
            padding: 20px / $ppr;
            background: #fff;
            margin-top: 24px / $ppr;
            .timing_mian-bottom-title {
                height: 35px / $ppr;
                line-height: 35px / $ppr;
                color: #999999;
                font-size: 24px / $ppr;
                color: #999999;
                margin-bottom: 24px / $ppr;
                i {
                    width: 28px / $ppr;
                    height: 28px / $ppr;
                    background: url("./img/icon_img_24.png") no-repeat;
                    background-size: 100% 100%;
                    display: inline-block;
                    margin-right: 8px / $ppr;
                    position: relative;
                    top: 3px / $ppr;
                }
            }
            .timing_mian-bottom-ul {
                .timing_mian-bottom-li {
                    padding: 24px / $ppr;
                    border: 1px solid #eaeaea;
                    border-radius: 10px / $ppr;
                    margin-bottom: 24px / $ppr;
                    font-size: 36px / $ppr;
                    font-weight: 600;
                    .timing_mian-bottom-li-span {
                        &.yesSned {
                            color: #999999;
                        }
                        &.noSned {
                            color: #5e89ef;
                        }
                    }
                    .timing_mian-li-right {
                        float: right;
                    }
                    .nohasSned {
                        width: 110px / $ppr;
                        text-align: center;
                        height: 50px / $ppr;
                        font-size: 24px / $ppr;
                        line-height: 50px / $ppr;
                        border-radius: 5px / $ppr;
                        display: inline-block;
                        background: #cccccc;
                        color: #fff;
                    }
                    .closehasSned,
                    .openhasSned {
                        width: 98px / $ppr;
                        height: 52px / $ppr;
                        border-radius: 52px / $ppr;
                        border: 1px solid #5e89ef;
                        display: inline-block;
                        position: relative;
                        float: right;
                        background: #5e89ef;
                        i {
                            width: 56px / $ppr;
                            height: 56px / $ppr;
                            border-radius: 50%;
                            background: #fff;
                            border: 1px solid #5e89ef;
                            display: inline-block;
                            position: relative;
                            right: -45px / $ppr;
                            top: -4px / $ppr;
                        }
                    }
                    .closehasSned {
                        border: 1px solid #dcdcdc;
                        background: #dcdcdc;
                        i {
                            position: relative;
                            left: -3px / $ppr;
                            top: -4px / $ppr;
                            border: 1px solid #dcdcdc;
                        }
                    }
                }
            }
        }
        .fix_bottom {
            position: fixed;
            width: 100%;
            height: 104px / $ppr;
            padding-top: 16px / $ppr;
            background-color: #fff;
            bottom: 0;
            left: 0;
            z-index: 1;
            .one_click-open {
                display: block;
                width: 672px / $ppr;
                height: 88px / $ppr;
                margin: 0 auto;
                background-color: #5e89ef;
                border-radius: 44px / $ppr;
                font-size: 34px / $ppr;
                color: #ffffff;
                border: none;
            }
        }
    }
}
.bottom-content {
    background: $c-fbg;
    display: flex;
    display: -webkit-flex;
    span {
        flex: 1;
        -webkit-flex: 1;
        display: inline-block;
        text-align: center;
        font-size: $lg;
        line-height: $h-header;
    }
    .btn {
        color: $c-tag;
    }
}
.picker-backdrop {
    position: fixed;
}
.tip_content {
    position: fixed;
    bottom: 40px / $ppr;
    width: 482px / $ppr;
    height: 82px / $ppr;
    line-height: 82px / $ppr;
    border-radius: 82px / $ppr;
    background: #333333;
    color: #fff;
    text-align: center;
    font-size: 30px / $ppr;
    left: 50%;
    margin-left: -241px / $ppr;
    z-index: 5;
}
</style>
